import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BusinessSolutionNavView from './business-solution-nav.presenter';
import {
  CIP_LOGIN_URL,
  CIP_LOGOUT_URL,
  ROUTE_PATHS,
} from '../../app-constants';
import { formatCustomerName, clearSessionStorage, getCustomerNameFromSecureAuth } from '../../app-actions';
import { LoadNewSelectedProduct } from '../../authorable-content/authorable-content.actions';

// Map & Connect
export const mapStateToProps = state => ({
  authenticated: state.dataBootStrapReducer.authentication.isAuthenticated,
  secureAuthenticated: state.dataBootStrapReducer.secureAuthAuthenticated,
  routePaths: ROUTE_PATHS,
  authorableRoutePathsContent: state.authorableContentReducer.authorableContent.routePaths,
  authenticatedNavButtons: [],
  cipLoginUrl: CIP_LOGIN_URL,
  cipLogoutUrl: CIP_LOGOUT_URL,
  customerName: formatCustomerName(),
  customerNameSecureAuth: getCustomerNameFromSecureAuth(),
  productSelectionList: state.authorableContentReducer.productSelectionList,
  uCidnSelectionList: state.authorableContentReducer.uCidnSelectionList,
  showProductSelection: state.authorableContentReducer.showProductSelectionChange,
  productError: state.authorableContentReducer.productError,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      clearSessionStorage,
      LoadNewSelectedProduct,
    }, dispatch),
});

const BusinessSolutionNav = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusinessSolutionNavView);

export default BusinessSolutionNav;
